<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("coffee.menu.content") }} </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <FormInput
                    id="coffeeTitle"
                    v-model="coffee.title"
                    :title="$t('coffee.content.buy_me_coffee')"
                />
                <FormTextArea
                    id="coffeeDesc"
                    v-model="coffee.desc"
                    :title="$t('coffee.content.extra_description')"
                    :rows="5"
                />
                <FormToggleSm
                    v-model="coffee.showDefaultAmount"
                    :title="$t('coffee.content.show_default_amount_buttons')"
                />
                <template v-if="coffee.showDefaultAmount">
                    <FormInput
                        id="coffeeAmount1"
                        v-model="coffee.amount1"
                        :title="$t('coffee.content.amount_no', { number: '1' })"
                        placeholder="5"
                    />
                    <FormInput
                        id="coffeeAmount2"
                        v-model="coffee.amount2"
                        :title="$t('coffee.content.amount_no', { number: '2' })"
                        placeholder="10"
                    />
                    <FormInput
                        id="coffeeAmount3"
                        v-model="coffee.amount3"
                        :title="$t('coffee.content.amount_no', { number: '3' })"
                        placeholder="15"
                    />
                </template>
                <FormToggleSm
                    v-model="coffee.showAmountInput"
                    :title="$t('coffee.content.show_amount_input')"
                />
                <FormInput
                    id="coffeeCurrency"
                    v-model="coffee.currency"
                    :title="$t('coffee.content.currency')"
                    placeholder="USD"
                />
                <FormToggleSm
                    v-model="coffee.showNoteInput"
                    :title="$t('coffee.content.show_note_input')"
                />
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { PageSidebar } from "@easy/ui/page-components";
import { mapState, mapActions } from "vuex";
import { FormInput, FormTextArea, FormToggleSm } from "@easy/ui/forms";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";

export default {
    name: "SidebarContent",
    components: {
        PageSidebar,
        FormInput,
        FormTextArea,
        FormToggleSm,
        cSaveButton,
    },
    computed: {
        ...mapState("coffee", ["coffee", "hasChanges"]),
    },
    setup() {
        useFocusOnQueryField();
    },
    methods: {
        ...mapActions("coffee/projects", ["saveSnapshot"]),
    },
};
</script>
